export const analyses = [
  {
    label: 'Información del centro y recomendación',
    key: 'info',
    description_field: 'desc_info',
    description: null,
    widgets: [],
    edit: false,
    loading: false
  },
  {
    label: 'Entorno del centro',
    key: 'entorno',
    description_field: 'desc_entorno',
    description: null,
    widgets: ['censo', 'censo_by_gender', 'renta', 'house_holds', 'marital_status', 'education'],
    edit: false,
    loading: false
  },
  {
    label: 'Competencia',
    key: 'competencia',
    description_field: 'desc_competencia',
    description: null,
    widgets: ['competencia'],
    edit: false,
    loading: false
  },
  {
    label: 'Análisis del consumidor',
    key: 'consumidor',
    description_field: 'desc_consumidor',
    description: null,
    widgets: ['gasto_total', 'gasto_medio_hogar', 'sonata_intereses', 'sonata_sociodemo'],
    edit: false,
    loading: false
  },
  {
    label: 'Análisis de los medios',
    key: 'medios',
    description_field: 'desc_medios',
    description: null,
    widgets: [],
    edit: false,
    loading: false,
    link: 'https://app.powerbi.com/view?r=eyJrIjoiZmY4NjUwYzYtODJkZS00NmQ5LTgyOTQtMDJkMzA2NDFhMjU1IiwidCI6IjZlODk5MmVjLTc2ZDUtNGVhNS04ZWFlLWIwYzVlNTU4NzQ5YSIsImMiOjh9',
    linkLabel: 'Acceder a dashboard'
  },
  {
    label: 'Análisis de directa',
    key: 'directa',
    description_field: 'desc_directa',
    description: null,
    widgets: [],
    edit: false,
    loading: false
  },
  {
    label: 'Eventos',
    key: 'eventos',
    description_field: 'desc_eventos',
    description: null,
    widgets: [],
    edit: false,
    loading: false
  }
]

export const widgetFields = [
  {
    full_label: 'GastoTotal_ArteYCultura',
    field: 'gt_art_cult',
    label: 'Arte y Cultura',
    category: 'Consumo categorías'
  },
  {
    full_label: 'GastoMedioHogar_ArteYCultura',
    field: 'gmh_art_cult',
    label: 'Arte y Cultura',
    category: 'Consumo Medio categorías'
  },
  {
    full_label: 'GastoTotal_BebidasAlcoholicasTabacoYNarcoticos',
    field: 'gt_beal_tn',
    label: 'Bebidas Alcohólicas, Tabaco y Narcóticos',
    category: 'Consumo categorías'
  },
  {
    full_label: 'GastoMedioHogar_BebidasAlcoholicasTabacoYNarcoticos',
    field: 'gmh_ba_tn',
    label: 'Bebidas Alcohólicas, Tabaco y Narcóticos',
    category: 'Consumo Medio categorías'
  },
  {
    full_label: 'GastoTotal_CasaYJardin',
    field: 'gt_ca_yjar',
    label: 'Casa y Jardín',
    category: 'Consumo categorías'
  },
  {
    full_label: 'GastoMedioHogar_CasaYJardin',
    field: 'gmh_ca_yjar',
    label: 'Casa y Jardín',
    category: 'Consumo Medio categorías'
  },
  {
    full_label: 'GastoTotal_ComidaYBebida',
    field: 'gt_comybeb',
    label: 'Comida y Bebida',
    category: 'Consumo categorías'
  },
  {
    full_label: 'GastoMedioHogar_ComidaYBebida',
    field: 'gmh_comybeb',
    label: 'Comida y Bebida',
    category: 'Consumo Medio categorías'
  },
  {
    full_label: 'GastoTotal_Educacion',
    field: 'gt_educ',
    label: 'Educación',
    category: 'Consumo categorías'
  },
  {
    full_label: 'GastoMedioHogar_Educacion',
    field: 'gmh_educ',
    label: 'Educación',
    category: 'Consumo Medio categorías'
  },
  {
    full_label: 'GastoTotal_Hogar',
    field: 'gt_hogar',
    label: 'Hogar',
    category: 'Consumo categorías'
  },
  {
    full_label: 'GastoMedioHogar_Hogar',
    field: 'gmh_hogar',
    label: 'Hogar',
    category: 'Consumo Medio categorías'
  },
  {
    full_label: 'GastoTotal_Moda',
    field: 'gt_moda',
    label: 'Moda',
    category: 'Consumo categorías'
  },
  {
    full_label: 'GastoMedioHogar_Moda',
    field: 'gmh_moda',
    label: 'Moda',
    category: 'Consumo Medio categorías'
  },
  {
    full_label: 'GastoTotal_OtrosBienesYServicios',
    field: 'gt_otros',
    label: 'Otros bienes y servicios',
    category: 'Consumo categorías'
  },
  {
    full_label: 'GastoMedioHogar_OtrosBienesYServicios',
    field: 'gmh_otros',
    label: 'Otros bienes y servicios',
    category: 'Consumo Medio categorías'
  },
  {
    full_label: 'GastoTotal_Salud',
    field: 'gt_salud',
    label: 'Salud',
    category: 'Consumo categorías'
  },
  {
    full_label: 'GastoMedioHogar_Salud',
    field: 'gmh_salud',
    label: 'Salud',
    category: 'Consumo Medio categorías'
  },
  {
    full_label: 'GastoTotal_Tecnologia',
    field: 'gt_tech',
    label: 'Tecnologia',
    category: 'Consumo categorías'
  },
  {
    full_label: 'GastoMedioHogar_Tecnologia',
    field: 'ghm_tech',
    label: 'Tecnología',
    category: 'Consumo Medio categorías'
  },
  {
    full_label: 'GastoTotal_Transportes',
    field: 'gt_transp',
    label: 'Transportes',
    category: 'Consumo categorías'
  },
  {
    full_label: 'GastoMedioHogar_Transportes',
    field: 'ghm_transp',
    label: 'Transportes',
    category: 'Consumo Medio categorías'
  },
  {
    full_label: 'GastoTotal_TravelComidaYBebida',
    field: 'gt_travel',
    label: 'Viajes - Comida y Bebida',
    category: 'Consumo categorías'
  },
  {
    full_label: 'GastoMedioHogar_TravelComidaYBebida',
    field: 'gmh_travel',
    label: 'Viajes - Comida y Bebida',
    category: 'Consumo Medio categorías'
  },
  {
    full_label: 'RentaMediaHogar',
    field: 'rmh',
    label: 'Renta Media por Hogar',
    category: 'Renta'
  },
  {
    full_label: 'female_menores_24',
    field: 'f_menor_24',
    label: 'Mujeres <= 24',
    category: 'Censo'
  },
  {
    full_label: 'female_mayores_65',
    field: 'f_mayor_65',
    label: 'Mujeres >= 65',
    category: 'Censo'
  },
  {
    full_label: 'female_25_34',
    field: 'f_25_34',
    label: 'Mujeres 25-34',
    category: 'Censo'
  },
  {
    full_label: 'female_35_44',
    field: 'f_35_44',
    label: 'Mujeres 35-44',
    category: 'Censo'
  },
  {
    full_label: 'female_45_54',
    field: 'f_45_54',
    label: 'Mujeres 45-54',
    category: 'Censo'
  },
  {
    full_label: 'female_55_64',
    field: 'f_55_64',
    label: 'Muejres 55-64',
    category: 'Censo'
  },
  {
    full_label: 'male_menores_24',
    field: 'm_menor_24',
    label: 'hombres <= 24',
    category: 'Censo'
  },
  {
    full_label: 'male_mayores_65',
    field: 'm_mayor_65',
    label: 'hombres >= 65',
    category: 'Censo'
  },
  {
    full_label: 'male_25_34',
    field: 'm_25_34',
    label: 'Hombres 25-34',
    category: 'Censo'
  },
  {
    full_label: 'male_35_44',
    field: 'm_35_44',
    label: 'Hombres 35-44',
    category: 'Censo'
  },
  {
    full_label: 'male_45_54',
    field: 'm_45_54',
    label: 'Hombres 45-54',
    category: 'Censo'
  },
  {
    full_label: 'male_55_64',
    field: 'm_55_64',
    label: 'Hombres 55-64',
    category: 'Censo'
  },
  {
    full_label: 'Sonata_ArtsAndEntertainment',
    field: 's_art_enter',
    label: 'Arte y Entretenimiento',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_Automotive',
    field: 's_auto',
    label: 'Automocion',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_Business',
    field: 's_busi',
    label: 'Negocios',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_Careers',
    field: 's_care',
    label: 'Carreras',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_Education',
    field: 's_educ',
    label: 'Educacion',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_FamilyAndParenting',
    field: 's_fam_par',
    label: 'Familia',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_FoodAndDrink',
    field: 's_foo_drink',
    label: 'Comida y Bebida',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_HealthAndFitness',
    field: 's_hea_fit',
    label: 'Salud y Deporte',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_HobbiesAndInterests',
    field: 's_hob_in',
    label: 'Hobbies e Intereses',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_HomeAndGarden',
    field: 's_hom_garde',
    label: 'Casa y Jardín',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_Law_GovermentAndPolitics',
    field: 's_law_gov',
    label: 'Ley, Gobierno y Politica',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_News',
    field: 's_news',
    label: 'Noticias',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_PersonalFinance',
    field: 's_pfinan',
    label: 'Finanzas Personales',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_Pets',
    field: 's_pets',
    label: 'Mascotas',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_RealEstate',
    field: 's_reales',
    label: 'Inmobiliario',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_ReligionAndSpirituality',
    field: 's_religion',
    label: 'Religion',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_Science',
    field: 's_scie',
    label: 'Ciencia',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_Shopping',
    field: 's_shop',
    label: 'Compras',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_Society',
    field: 's_soci',
    label: 'Sociedad',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_Sports',
    field: 's_spor',
    label: 'Deportes',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_StyleAndFashion',
    field: 's_sty_fash',
    label: 'Moda y Estilo',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_TechnologyAndComputing',
    field: 's_tech',
    label: 'Tecnologia',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_Travel',
    field: 's_travel',
    label: 'Viajes',
    category: 'Audiencia Mobile - Intereses'
  },
  {
    full_label: 'Sonata_female_menores_24',
    field: 's_f_menor_24',
    label: 'mujeres <= 24',
    category: 'Audiencia Mobile - Sociodemo'
  },
  {
    full_label: 'Sonata_female_mayores_65',
    field: 's_f_mayor_65',
    label: 'mujeres >= 65',
    category: 'Audiencia Mobile - Sociodemo'
  },
  {
    full_label: 'Sonata_female_25_34',
    field: 's_f_25_34',
    label: 'mujeres 25-34',
    category: 'Audiencia Mobile - Sociodemo'
  },
  {
    full_label: 'Sonata_female_35_44',
    field: 's_f_35_44',
    label: 'mujeres 35-44',
    category: 'Audiencia Mobile - Sociodemo'
  },
  {
    full_label: 'Sonata_female_45_54',
    field: 's_f_45_54',
    label: 'mujeres 45-54',
    category: 'Audiencia Mobile - Sociodemo'
  },
  {
    full_label: 'Sonata_female_55_64',
    field: 's_f_55_64',
    label: 'Mujeres 55-64',
    category: 'Audiencia Mobile - Sociodemo'
  },
  {
    full_label: 'Sonata_male_menores_24',
    field: 's_m_menor_24',
    label: 'hombres <= 24',
    category: 'Audiencia Mobile - Sociodemo'
  },
  {
    full_label: 'Sonata_male_mayores_65',
    field: 's_m_mayor_65',
    label: 'hombres >= 65',
    category: 'Audiencia Mobile - Sociodemo'
  },
  {
    full_label: 'Sonata_male_25_34',
    field: 's_m_25_34',
    label: 'Hombres 25-34',
    category: 'Audiencia Mobile - Sociodemo'
  },
  {
    full_label: 'Sonata_male_35_44',
    field: 's_m_35_44',
    label: 'Hombres 35-44',
    category: 'Audiencia Mobile - Sociodemo'
  },
  {
    full_label: 'Sonata_male_45_54',
    field: 's_m_45_54',
    label: 'Hombres 45-54',
    category: 'Audiencia Mobile - Sociodemo'
  },
  {
    full_label: 'Sonata_male_55_64',
    field: 's_m_55_64',
    label: 'Hombres 55-64',
    category: 'Audiencia Mobile - Sociodemo'
  },
  {
    full_label: '16_64_divorced',
    field: '_16_64_div',
    label: 'divorciados 16-64',
    category: 'Marital Status'
  },
  {
    full_label: '16_64_married',
    field: '_16_64_mar',
    label: 'casados 16-64',
    category: 'Marital Status'
  },
  {
    full_label: '16_64_separated',
    field: '_16_64_sep',
    label: 'separados 16-64',
    category: 'Marital Status'
  },
  {
    full_label: '16_64_single',
    field: '_16_64_sing',
    label: 'solteros 16-64',
    category: 'Marital Status'
  },
  {
    full_label: '16_64_widowed',
    field: '_16_64_wid',
    label: 'viudos 16-64',
    category: 'Marital Status'
  },
  {
    full_label: 'mayores_64_divorced',
    field: 'mayor_64_div',
    label: 'divorciados >= 64',
    category: 'Marital Status'
  },
  {
    full_label: 'mayores_64_married',
    field: 'mayor_64_mar',
    label: 'casados >= 64',
    category: 'Marital Status'
  },
  {
    full_label: 'mayores_64_separated',
    field: 'mayor_64_sep',
    label: 'separados >= 64',
    category: 'Marital Status'
  },
  {
    full_label: 'mayores_64_single',
    field: 'mayor_64_sing',
    label: 'solteros >= 64',
    category: 'Marital Status'
  },
  {
    full_label: 'mayores_64_widowed',
    field: 'mayor_64_wid',
    label: 'viudos >= 64',
    category: 'Marital Status'
  },
  {
    full_label: 'menores_16_divorced',
    field: 'menor_16_div',
    label: 'divorciados <= 16',
    category: 'Marital Status'
  },
  {
    full_label: 'menores_16_married',
    field: 'menor_16_mar',
    label: 'casados <= 16',
    category: 'Marital Status'
  },
  {
    full_label: 'menores_16_separated',
    field: 'menor_16_sep',
    label: 'separados <= 16',
    category: 'Marital Status'
  },
  {
    full_label: 'menores_16_single',
    field: 'menor_16_sing',
    label: 'solteros <= 16',
    category: 'Marital Status'
  },
  {
    full_label: 'menores_16_widowed',
    field: 'menor_16_wid',
    label: 'viudos <= 16',
    category: 'Marital Status'
  },
  {
    full_label: 'viviendas_1p',
    field: 'vivienda_1p',
    label: '1 persona',
    category: 'House Holds'
  },
  {
    full_label: 'viviendas_2p',
    field: 'vivienda_2p',
    label: '2 personas',
    category: 'House Holds'
  },
  {
    full_label: 'viviendas_3p',
    field: 'vivienda_3p',
    label: '3 personas',
    category: 'House Holds'
  },
  {
    full_label: 'viviendas_4p',
    field: 'vivienda_4p',
    label: '4 personas',
    category: 'House Holds'
  },
  {
    full_label: 'viviendas_5p',
    field: 'vivienda_5p',
    label: '5 personas',
    category: 'House Holds'
  },
  {
    full_label: 'viviendas_6p_more',
    field: 'vivienda_6p',
    label: '6 personas o más',
    category: 'House Holds'
  },
  {
    full_label: 'basic_studies',
    field: 'basic_stu',
    label: 'Estudios Básicos',
    category: 'Education'
  },
  {
    full_label: 'illiterate',
    field: 'illi',
    label: 'Sin Estudios',
    category: 'Education'
  },
  {
    full_label: 'intermediate_studies',
    field: 'medi_stu',
    label: 'Estudios Intermedios',
    category: 'Education'
  },
  {
    full_label: 'uneducated',
    field: 'not_edu',
    label: 'Sin Escolarizar',
    category: 'Education'
  },
  {
    full_label: 'advanced_studies',
    field: 'adva_stu',
    label: 'Estudios Avanzados',
    category: 'Education'
  },
  // {
  //   full_label: 'completed_primary',
  //   field: 'comp_prim',
  //   label: 'Primaria Completada',
  //   category: 'Education'
  // },
  // {
  //   full_label: 'some_primary',
  //   field: 'some_prim',
  //   label: 'Primaria Comenzada',
  //   category: 'Education'
  // },
  // {
  //   full_label: 'some_secondary',
  //   field: 'some_second',
  //   label: 'Secundaria Comenzada',
  //   category: 'Education'
  // },
  // {
  //   full_label: 'no_schooling',
  //   field: 'not_school',
  //   label: 'No Escolarizados',
  //   category: 'Education'
  // },
  // {
  //   full_label: 'high',
  //   field: 'high',
  //   label: 'Secundaria Completada',
  //   category: 'Education'
  // },
  {
    full_label: 'competencia_Videogames',
    field: 'comp_videogames',
    label: 'CONSOLAS Y VIDEOJUEGOS',
    category: 'Competencia'
  },
  {
    full_label: 'competencia_Sports',
    field: 'comp_sports',
    label: 'DEPORTES',
    category: 'Competencia'
  },
  {
    full_label: 'competencia_Mass_Market',
    field: 'comp_mass_market',
    label: 'GRAN CONSUMO',
    category: 'Competencia'
  },
  {
    full_label: 'competencia_Home',
    field: 'comp_home',
    label: 'HOGAR',
    category: 'Competencia'
  },
  {
    full_label: 'competencia_Toys',
    field: 'comp_toys',
    label: 'JUGUETES',
    category: 'Competencia'
  },
  {
    full_label: 'competencia_Fashion',
    field: 'comp_fashion',
    label: 'MODA',
    category: 'Competencia'
  },
  {
    full_label: 'competencia_Leissure',
    field: 'comp_leissure',
    label: 'OCIO Y CULTURA',
    category: 'Competencia'
  },
  {
    full_label: 'competencia_MakeUp',
    field: 'comp_makeup',
    label: 'PERFUMERÍA Y MAQUILLAJE',
    category: 'Competencia'
  },
  {
    full_label: 'competencia_Technology',
    field: 'comp_technology',
    label: 'TECNOLOGÍA',
    category: 'Competencia'
  },
  {
    full_label: 'competencia_Pets',
    field: 'comp_pets',
    label: 'MASCOTAS',
    category: 'Competencia'
  }
].map(f => ({ ...f, value: 0 }))

export const widgets = [
  {
    key: 'gasto_total',
    display: 'percent-bar',
    fields: widgetFields.filter(w => w.category === 'Consumo categorías'),
    category: 'Gasto total por categorías',
    symbol: '€'
  },
  {
    key: 'gasto_medio_hogar',
    display: 'percent-bar',
    fields: widgetFields.filter(w => w.category === 'Consumo Medio categorías'),
    category: 'Gasto medio del hogar por categorías',
    average: true,
    symbol: '€'
  },
  {
    key: 'renta',
    display: 'single-value',
    fields: widgetFields.filter(w => w.category === 'Renta'),
    category: 'Renta',
    average: true
  },
  {
    key: 'censo',
    display: 'multi-bar-chart',
    fields: widgetFields.filter(w => w.category === 'Censo'),
    category: 'Censo',
    config: {
      categories: [/_menor_24$/, /_25_34$/, /_35_44$/, /_45_54$/, /_55_64$/, /_mayor_65$/],
      colors: {
        f: 'var(--colorFemale)',
        m: 'var(--colorMale)'
      },
      labels: {
        f: 'Mujeres',
        m: 'Hombres',
        _menor_24: '< 24',
        _25_34: '25 - 34',
        _35_44: '35 - 44',
        _45_54: '45 - 54',
        _55_64: '55 - 64',
        _mayor_65: '> 64'
      }
    }
  },
  {
    key: 'censo_by_gender',
    display: 'doughnut-chart',
    fields: widgetFields.filter(w => w.category === 'Censo'),
    category: 'Distribución por género',
    config: {
      sort: false,
      categories: [/m_/, /f_/],
      colors: {
        f_: 'var(--colorFemale)',
        m_: 'var(--colorMale)'
      },
      labels: {
        f_: 'Mujer',
        m_: 'Hombre'
      }
    }
  },
  {
    key: 'marital_status',
    display: 'percent-bar-sum',
    fields: widgetFields.filter(w => w.category === 'Marital Status'),
    category: 'Estado civil',
    config: {
      colors: {
        sep: '#8dd3c7',
        div: '#ffffb3',
        mar: '#7fc97f',
        wid: '#fb8072',
        sing: '#80b1d3'
      },
      labels: {
        menor_16_: '< 16',
        _16_64_: '16 - 64',
        mayor_64_: '> 64',
        sep: 'Separado',
        div: 'Divorciado',
        mar: 'Casado',
        sing: 'Soltero',
        wid: 'Viudo'
      },
      categories: [/div$/, /mar$/, /wid$/, /sing$/, /sep$/]
      // categories: [/^menor_16_/, /^_16_64_/, /^mayor_64_/],
      // d3 set3 ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69","#fccde5","#d9d9d9","#bc80bd","#ccebc5","#ffed6f"]
      // d3 pastel ["#7fc97f","#beaed4","#fdc086","#ffff99","#386cb0","#f0027f","#bf5b17","#666666"]
      // d3 category 10 ["#1f77b4","#ff7f0e","#2ca02c","#d62728","#9467bd","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf"   ]
    }
  },
  {
    key: 'house_holds',
    display: 'percent-bar',
    fields: widgetFields.filter(w => w.category === 'House Holds'),
    category: 'Vivienda'
  },
  {
    key: 'education',
    display: 'percent-bar',
    fields: widgetFields.filter(w => w.category === 'Education'),
    category: 'Educación'
  },
  {
    key: 'sonata_sociodemo',
    display: 'multi-bar-chart',
    fields: widgetFields.filter(w => w.category === 'Audiencia Mobile - Sociodemo'),
    category: 'Audiencia Mobile - Sociodemo',
    config: {
      categories: [/_menor_24$/, /_25_34$/, /_35_44$/, /_45_54$/, /_55_64$/, /_mayor_65$/],
      colors: {
        s_f: 'var(--colorFemale)',
        s_m: 'var(--colorMale)'
      },
      labels: {
        s_f: 'Mujeres',
        s_m: 'Hombres',
        _menor_24: '< 24',
        _25_34: '25 - 34',
        _35_44: '35 - 44',
        _45_54: '45 - 54',
        _55_64: '55 - 64',
        _mayor_65: '> 64'
      }
    }
  },
  {
    key: 'sonata_intereses',
    display: 'percent-bar',
    fields: widgetFields.filter(w => w.category === 'Audiencia Mobile - Intereses'),
    category: 'Audiencia Mobile - Intereses'
  },
  {
    key: 'competencia',
    display: 'competitors',
    fields: widgetFields.filter(w => w.category === 'Competencia'),
    category: 'Competencia'
  }
]
